import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-gray-800 shadow-lg">
      <div className="container mx-auto px-4 flex items-center justify-between h-16">
        <Link to="/" className="text-xl font-bold text-white">
          AI Art Generator
        </Link>
        {/* Hamburger menu for mobile */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-300 focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        {/* Links */}
        <div className={`flex-col md:flex-row md:flex md:items-center md:space-x-4 absolute md:static top-16 left-0 w-full md:w-auto bg-gray-800 md:bg-transparent z-50 transition-all duration-200 ${menuOpen ? 'flex' : 'hidden'}`}>
          <Link to="/" className="block px-4 py-2 text-gray-300 hover:text-white">Home</Link>
          <Link to="/generate" className="block px-4 py-2 text-gray-300 hover:text-white">Generate</Link>
          <Link to="/gallery" className="block px-4 py-2 text-gray-300 hover:text-white">Gallery</Link>
          <Link to="/about" className="block px-4 py-2 text-gray-300 hover:text-white">About</Link>
          <Link to="/help" className="block px-4 py-2 text-gray-300 hover:text-white">Help</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 